import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { menuItemParams } from '../../../../types'
import Child from '../../../Main/SubMenu/Child'
import Parent from '../../../Main/SubMenu/Parent'
import style from './style.module.scss'
import { motion } from 'framer-motion'

type itemMainNavMobile = {
    item: menuItemParams
    handleClick: Dispatch<SetStateAction<number>>
}

const ItemMainNavMobile: React.FC<itemMainNavMobile> = ({ item, handleClick }) => {
    if (item.children.length > 0) {
        return (
            <div className={style.item} onClick={() => handleClick(item.ID)}>
                {item.title}
                <i className="fi-rs-angle-small-right" />
            </div>
        )
    }

    return (
        <a href={item.url} target={item.target} className={style.item}>
            {item.title}
        </a>
    )
}

type subItemMainNavMobile = {
    item: menuItemParams
}

const SubItemMainNavMobile: React.FC<subItemMainNavMobile> = ({ item }) => {
    return (
        <nav className={style.child}>
            <h3 className={style.title}>{item.title}</h3>
            <ul>
                {item.children.map((child, index) => {
                    if (child.url === '#container') {
                        return (
                            child.children.length > 0 &&
                            child.children.map((children, i) => (
                                <li className={style.container} key={i}>
                                    <Parent item={children} />
                                    <Child item={children} />
                                </li>
                            ))
                        )
                    }
                    return (
                        <li key={index}>
                            <Parent item={child} />
                            <Child item={child} />
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}

type mainNavMobileProps = {
    nav: menuItemParams[]
    active: number | null
    setActive: Dispatch<SetStateAction<number>>
}

const MainNavMobile: React.FC<mainNavMobileProps> = ({ nav, active, setActive }) => {
    const [initMenu, setInitMenu] = useState(false)

    useEffect(() => {
        if (active) {
            setInitMenu(true)
        }
    }, [active])

    if (active) {
        const subItem = nav.find((item) => item.ID === active)
        if (subItem) {
            return <SubItemMainNavMobile item={subItem} />
        }
    }

    const variants = {
        open: {
            transition: { staggerChildren: 0.1, delayChildren: 0.2 },
        },
        closed: {
            transition: { staggerChildren: 0.1, staggerDirection: -1 },
        },
    }

    const itemVariants = {
        open: {
            y: 0,
            opacity: 1,
            transition: {
                y: { stiffness: 1000, velocity: -100 },
            },
        },
        closed: {
            y: 50,
            opacity: 0,
            transition: {
                y: { stiffness: 1000 },
            },
        },
    }

    return (
        <nav className={style.main}>
            <motion.ul
                variants={initMenu ? undefined : variants}
                initial="closed"
                animate="open"
                exit="closed"
            >
                {nav.map((item, index) => (
                    <motion.li key={index} variants={initMenu ? undefined : itemVariants}>
                        <ItemMainNavMobile item={item} handleClick={setActive} />
                    </motion.li>
                ))}
            </motion.ul>
        </nav>
    )
}

export default MainNavMobile
